/*
    Debounce:
        The result of debounce(f, ms) decorator is a wrapper that suspends calls to f until there’s ms milliseconds of 
        inactivity (no calls, “cooldown period”), then invokes f once with the latest arguments.
        
        Or

        Debounce is a function when you want it to execute only once after a defined interval of time. 
        If the event occurs multiple times within the interval, the interval is reset each time.
        Example:
        A user is typing into an input field and you want to execute a function, such as a call to the server,
        only when the user stops typing for a certain interval, such as 500ms.
*/

export const debounce = (fn, delay) => {
    let timer;
    return function(...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
};

/* 
    Throttle:
    Throttle a function when you want it to execute periodically with an interval.
    Example A user is typing into a field continuously for 30s but you want to make sure you capture a users input every 1s 
    and perform an action.
*/

export const throttle = (fn, delay) => {
    let lastFunc, lastRan;
    return function(...args) {
        if (!lastRan) {
            fn.apply(this, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(() => {
                if (Date.now() - lastRan >= delay) {
                    fn.apply(this, args);
                    lastRan = Date.now();
                }
            }, delay - (Date.now() - lastRan));
        }
    };
};
